export var playlistBusinessTypesCacheKey = "playlist-business-types";
